
<template>
  <!-- <span v-if="isExternalLink(to)" @click="goTo(to)" ref="noopener"  target="_blank">
    <slot/>
  </span> -->
  <span @click="goTo(to)">
    <slot />
  </span>
</template>

<script>
import { validateURL } from '@/utils/validate'

export default {
  props: {
    to: {
      type: String,
      required: true
    }
  },

  methods: {
    isExternalLink(routePath) {
      return validateURL(routePath)
    },
    goTo(to) {
      this.$router.push({ name: to })
    }
  }
}
</script>
